<template>
  <v-card>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      class="px-2 text-left"
      label="ค้นหา"
      single-line
      hide-details
    />
    <v-data-table
      :headers="headers"
      calculate-widths
      :search="search"
      :items="members"
      :items-per-page="10"
      class="elevation-2"
    />
  </v-card>
</template>

<script>
export default {
  name: 'AffMember',
  props: {
    members: {
      type: Array,
    },
  },
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'ชื่อ',
          align: 'start',
          value: 'name',
        },
        {
          text: 'ยอดแทง',
          value: 'bill',
          align: 'center',
        },
        {
          text: 'วันสมัคร',
          value: 'registerdate',
          align: 'end',
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
   
  },
  methods: {},
};
</script>
